import { avatarColor, initialsOf } from '../utils/avatar-color';

export function Avatar({
  name,
  size = 40,
  className,
}: {
  name: string | null | undefined;
  size?: number;
  className?: string;
}) {
  const bg = avatarColor(name);
  const initials = initialsOf(name);
  return (
    <span
      style={{ backgroundColor: bg, width: size, height: size, fontSize: Math.round(size * 0.42) }}
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full font-semibold text-white ${className ?? ''}`}
      aria-label={`Avatar for ${name ?? 'unknown contact'}`}
    >
      {initials}
    </span>
  );
}
